"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable no-param-reassign */

var NavigationBarItems = function NavigationBarItems(_ref) {
  var children = _ref.children,
    childrenRef = _ref.childrenRef,
    navIndex = _ref.navIndex;
  return _react["default"].Children.map(children, function (child, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "menuitem"
    }, /*#__PURE__*/_react["default"].cloneElement(child, {
      ref: function ref(el) {
        childrenRef.current[i] = el;
      },
      tabIndex: i === navIndex ? 0 : -1
    }));
  });
};
var _default = exports["default"] = NavigationBarItems;